import React from "react";

import { createStyles, Theme, withStyles } from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import ScreeningReportData from "./ScreeningReportData";
import screeningStyles from "./screeningReport.module.css";
import commonStyles from '../common/common.module.css';
import ScreeningReport from "../../models/ScreeningReport";

interface ScreeningReportTableProps {
  classes: any;
  page: number;
  rowsPerPage: number;
  count: number;
  filteredReport: Array<ScreeningReport>;
};

const styles = (theme: Theme) =>
  createStyles({
    parentTh: {
      display: 'table-row-group',
      color: 'var(--primaryblue) !important',
      borderBottom: '1px solid var(--primaryblue)',
      backgroundColor: 'white'
    },
    emptyTable: {
      textAlign: 'center',
      borderRadius: 'var(--tb-border-radius) !important',
    },
  });

const screeningReportTable = (props: ScreeningReportTableProps) => {
  const { classes } = props;

  return (   
    <div className={ `${ commonStyles.wrapper } ${ screeningStyles.wrapperTable }` } >
      <h3 className={ commonStyles.header } >Screened Airwaybills</h3>
      <div className={ screeningStyles.screeningTableWrapper }>
        <Table aria-label="collapsible table" className={ screeningStyles.screeningTable }>
          <TableHead
            className={ [screeningStyles.Mainth, classes.parentTh].join(" ") }
          >
            <TableRow>
              <TableCell className={ screeningStyles.tableCell }>AWB</TableCell>
              <TableCell className={ screeningStyles.tableCell }>Pcs</TableCell>
              <TableCell className={ screeningStyles.tableCell }>Wgt</TableCell>
              <TableCell className={ screeningStyles.tableCell }>Origin</TableCell>
              <TableCell className={ screeningStyles.tableCell }>Dest</TableCell>
              <TableCell className={ screeningStyles.tableCell }>Booked Flight</TableCell>
              <TableCell className={ screeningStyles.tableCell }>
                Forwarder/Interline/RFS
              </TableCell>
              <TableCell className={ screeningStyles.tableCell }>Profile</TableCell>
              <TableCell className={ screeningStyles.tableCell }>CCSF</TableCell>
              <TableCell className={ screeningStyles.tableCell }>
                Received
              </TableCell>
              <TableCell className={ screeningStyles.tableCell }>
                eCSD
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={ screeningStyles.screeningTableBody }>
            <TableRow className={ screeningStyles.BlankRow }></TableRow>
            {props.filteredReport
              .slice(
                props.page * props.rowsPerPage,
                props.page * props.rowsPerPage + props.rowsPerPage
              )
              .map((row: ScreeningReport, i: number) => (
                <ScreeningReportData key={ i } data={ row } />
              ))}
            {props.count === 0 && (
              <TableRow>
                <TableCell
                  colSpan={10}
                  component="th"
                  scope="row"
                  className={ classes.emptyTable }
                >
                  No records to display
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};

export default withStyles(styles)(screeningReportTable);
